import { useLocation } from 'react-router-dom';

import { parseUrlQuery } from '$utils/parseUrlQuery';

type UtmTagsType = {
  utm_medium?: string;
  utm_source?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
};

interface IGet {
  (): {
    utmMedium?: string;
    utmSource?: string;
    utmCampaign?: string;
    utmContent?: string;
    utmTerm?: string;
    utmTrafficSource?: string | null;
    utmReferralLink?: string;
  } | null;
}

interface ISet {
  (): void;
}

function useUtmTags(): { get: IGet; set: ISet } {
  const query = parseUrlQuery(useLocation().search);

  const get = () => {
    if (document.cookie.includes('utm_') || document.cookie.includes('trafficSource')) {
      const getCookieValue = (name: string): string | undefined =>
        document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || undefined;

      return {
        utmMedium: getCookieValue('utm_medium'),
        utmSource: getCookieValue('utm_source'),
        utmCampaign: getCookieValue('utm_campaign'),
        utmContent: getCookieValue('utm_content'),
        utmTerm: getCookieValue('utm_term'),
        utmTrafficSource: getCookieValue('trafficSource'),
        utmReferralLink: getCookieValue('utm_medium'),
      };
    } else if (new Date().getTime() < new Date('2025-06-18T00:00:00').getTime()) {
      const utmTags: UtmTagsType = JSON.parse(localStorage.getItem('utmTags') || '{}');

      if (Object.keys(utmTags).length > 0) {
        return {
          utmMedium: utmTags.utm_medium,
          utmSource: utmTags.utm_source,
          utmCampaign: utmTags.utm_campaign,
          utmContent: utmTags.utm_content,
          utmTerm: utmTags.utm_term,
          utmTrafficSource: localStorage.getItem('trafficSource'),
          utmReferralLink: utmTags.utm_medium,
        };
      }
    }

    return null;
  };

  const set = () => {
    const d = new Date();
    const dias = 30;
    d.setTime(d.getTime() + dias * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();

    if (document.referrer.length > 0) {
      const url = new URL(document.referrer);

      if (url.hostname !== document.domain) {
        document.cookie = 'trafficSource=' + document.referrer + '; ' + expires + ';domain=.getboat.com;path=/';
      }
    }

    if (query) {
      Object.keys(query).forEach((key) => {
        if (['utm_medium', 'utm_source', 'utm_campaign', 'utm_content', 'utm_term'].includes(key)) {
          document.cookie = key + '=' + query[key] + '; ' + expires + ';domain=.getboat.com;path=/';
        }
      });

      if (query['click_id']) {
        localStorage.setItem('cityAds_click_id', query['click_id'] + '');
      }

      if (query['gclid']) {
        localStorage.setItem('cityAds_gclid', query['gclid'] + '');
      }
    }
  };

  return { get, set };
}

export default useUtmTags;
